import { Link, useLocation } from 'react-router-dom';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '@/components/ui-kit/breadcrumb';
import { BREADCRUMB_CUSTOM_TITLES } from '@/constant/breadcrumb-custom-title';

const formatSegment = (segment: string) =>
  decodeURIComponent(segment)
    .replace(/-/g, ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

const PageBreadcrumb = ({ breadcrumbIndex }: { breadcrumbIndex?: number }) => {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);
  const visibleSegments =
    typeof breadcrumbIndex === 'number' ? segments.slice(0, breadcrumbIndex) : segments;

  if (visibleSegments.length === 0) return null;

  return (
    <Breadcrumb className="hidden md:flex">
      <BreadcrumbList>
        {visibleSegments.map((segment, index) => {
          const href = `/${visibleSegments.slice(0, index + 1).join('/')}`;
          const label = BREADCRUMB_CUSTOM_TITLES[href] || formatSegment(segment);
          const isLast = index === visibleSegments.length - 1;

          return (
            <BreadcrumbItem key={href}>
              {isLast ? (
                <BreadcrumbPage className="text-low-emphasis">{label}</BreadcrumbPage>
              ) : (
                <>
                  <BreadcrumbLink asChild>
                    <Link to={href} className="text-foreground hover:text-foreground">
                      {label}
                    </Link>
                  </BreadcrumbLink>
                  <BreadcrumbSeparator />
                </>
              )}
            </BreadcrumbItem>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
};

export default PageBreadcrumb;
